import base from './base.json';
import envConfig from './EnvConfig';
import get from 'lodash/get';
import merge from 'lodash/merge';

class Config {
  config: {};

  constructor() {
    const configOverwrite = envConfig.getConfig();
    // Local dev only: opt-in per-key overrides. Lets a developer repoint an
    // individual backend without switching the whole REACT_APP_APP_ENV (which
    // would move every URL off local). Unset env vars are `undefined`, which
    // lodash `merge` skips — so deployed envs and CI are unchanged.
    // e.g. set REACT_APP_DASHBOARD_BACKEND_URL=http://localhost:3001/ to route
    // dashboards traffic through the local learnops gateway (which can proxy it
    // to csi-3, see PROXY_DASHBOARDS in learnops) instead of a local container.
    const envOverrides = {
      dashboardBackendURL: process.env.REACT_APP_DASHBOARD_BACKEND_URL,
    };
    this.config = merge(base, configOverwrite, envOverrides);
  }

  get(key: string, defaultValue?: any) {
    return get(this.config, key, defaultValue);
  }
}

const config = new Config();

export default config;
